import {IconNames} from "@blueprintjs/icons";

export function getIconNames() {
  return Object.values(IconNames);
}

export function sanitizeHTML(html: string) {
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, "text/html");

  const unsafeTags = ["script", "style", "iframe", "object"];
  unsafeTags.forEach((tag) => {
    const elements = doc.getElementsByTagName(tag);
    while (elements.length > 0) {
      elements[0].parentNode?.removeChild(elements[0]);
    }
  });

  return doc.body.innerHTML || "";
}
